<template>
  <!-- 资源入库 -->
  <div class="layout">
    <div class="menu">
      <Menu topIndex="toStorage"></Menu>
    </div>
    <div class="leftSide">
      <LeftSideBar
        current="toStorage"
        leftIndex="sourceToStorage"
      ></LeftSideBar>
    </div>
    <div id="deptContentBox" class="base-content">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="条目类型数据资源入库" name="first"></el-tab-pane>
        <el-tab-pane label="图书数据入库" name="second"> </el-tab-pane>
        <el-tab-pane label="辞典工具类型数据入库" name="third"></el-tab-pane>
        <el-tab-pane label="专项数据资源入库" name="fourth"></el-tab-pane>
        <el-tab-pane label="文章数据入库" name="fifth"> </el-tab-pane>
        <el-tab-pane label="论文数据入库" name="sixth"></el-tab-pane>
        <el-tab-pane label="问答对资源入库" name="seventh"></el-tab-pane>
      </el-tabs>
      <!-- 内容div -->
      <!-- 上方按钮 -->
      <div>
        <div class="sourceBox">
          <span class="sourceTitle">来源：</span>
          <el-select
            placeholder="请选择来源"
            v-model="sourceContent"
            @change="tableRefresh()"
            clearable
          >
            <el-option
              v-for="item in sourceList"
              :key="item.id"
              :value="item.id"
              :label="item.name"
            >
            </el-option>
          </el-select>
        </div>
        <el-button
          type="text"
          size="small"
          icon="el-icon-upload"
          :disabled="sourceContent == ''"
          @click="firstCreate()"
          >上传资源包</el-button
        >
        <el-button
          type="text"
          size="small"
          icon="el-icon-refresh"
          @click="preCheck('totrans')"
          :disabled="sourceContent == ''"
          v-if="newType == 10"
          >数据转换</el-button
        >
        <el-button
          type="text"
          size="small"
          icon="el-icon-download"
          @click="preCheck('toimport')"
          :disabled="sourceContent == ''"
          >资源导入</el-button
        >
        <el-button
          type="text"
          size="small"
          icon="el-icon-document-add"
          @click="preCheck('getImprotLog')"
          :disabled="sourceContent == ''"
          v-if="newType == 10"
          >导入日志查看</el-button
        >
        <el-button
          type="text"
          size="small"
          icon="el-icon-document-add"
          @click="templateDownload()"
          :disabled="sourceContent == ''"
          v-if="newType == 140"
          >下载导入模板</el-button
        >
        <el-button
          type="text"
          size="small"
          icon="el-icon-document"
          :disabled="sourceContent == ''"
          @click="preCheck('getTransLog')"
          v-if="newType == 10"
          >转换日志查看</el-button
        >
        <el-button
          type="text"
          size="small"
          icon="el-icon-folder-add"
          :disabled="sourceContent == ''"
          @click="preCheck('importLogDownload')"
          v-if="newType == 10"
          >导入日志下载</el-button
        >
        <el-button
          type="text"
          size="small"
          icon="el-icon-folder-checked"
          :disabled="sourceContent == ''"
          @click="preCheck('transLogDownload')"
          v-if="newType == 10"
          >转换日志下载</el-button
        >
      </div>
      <!-- 主列表 -->
      <el-table
        :data="listTableData"
        v-loading="tableLoading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-customClass="loadingStyles"
        style="width: 100%"
        class="maintable"
        border
        :header-cell-style="{ background: '#f8f8f8' }"
        @selection-change="handleTableSelectionChange"
      >
        <el-table-column
          type="selection"
          min-width="55"
          align="center"
        ></el-table-column>
        <el-table-column type="index" min-width="50" align="center">
        </el-table-column>
        <el-table-column
          prop="name"
          show-overflow-tooltip
          width="200"
          label="资源名称"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="path"
          min-width="80"
          label="资源路径"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="isImport"
          show-overflow-tooltip
          label="是否已导入"
          width="100"
          align="center"
        >
          <template slot-scope="scope">
            <el-tag type="info" effect="dark" v-if="scope.row.isImport == 10"
              >否</el-tag
            >
            <el-tag type="success" effect="dark" v-if="scope.row.isImport == 20"
              >是</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column
          prop="isChange"
          show-overflow-tooltip
          label="是否已转换"
          width="100"
          align="center"
          v-if="newType == 10"
        >
          <template slot-scope="scope">
            <el-tag type="info" effect="dark" v-if="scope.row.isChange == 10"
              >否</el-tag
            >
            <el-tag type="success" effect="dark" v-if="scope.row.isChange == 20"
              >是</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column
          prop="syncTime"
          show-overflow-tooltip
          label="同步时间"
          align="center"
        >
        </el-table-column>
      </el-table>
      <!-- 列表分页 -->
      <div class="pagination-box">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalSize"
        >
        </el-pagination>
      </div>
    </div>
    <!-- 上传资源包弹窗 -->
    <el-dialog
      title="上传资源包"
      :visible.sync="createDialog"
      width="600px"
      :close-on-click-modal="false"
      @open="noClick = false"
    >
      <div class="uploadBox">
        <el-upload
          ref="upload"
          action="/zyk/storage/upload"
          :headers="headers"
          :file-list="fileList"
          name="upfile"
          :before-upload="beforeUpload"
          :on-success="uploadSuccess"
          :auto-upload="false"
          accept=".zip"
          :data="upLodeData"
          :limit="1"
        >
          <div slot="tip" class="el-upload__tip">
            必须为zip压缩文件,且资源超过上传上限4G，如仍需上传，请联系管理员。
          </div>
          <el-button slot="trigger" size="small" type="primary"
            >选择文件</el-button
          >
          <el-button size="small" type="success" @click="submitUpload"
            >开始上传</el-button
          >
        </el-upload>
      </div>
    </el-dialog>

    <!-- 数据转换、导入弹窗 -->
    <el-dialog
      :title="runTimeTitle"
      :visible.sync="transDialog"
      width="600px"
      :close-on-click-modal="false"
      @open="noClick = false"
    >
      <div class="message">
        <p>
          <span>{{ startTime }}</span
          >：<span class="currentName">数据操作开始！</span>
        </p>
        <p class="logContent"></p>
      </div>
    </el-dialog>
    <!-- 日志弹窗 -->
    <el-dialog
      :title="checkLogTitle"
      :visible.sync="logMMesDialog"
      width="600px"
      :close-on-click-modal="false"
    >
      <pre>{{ logChechContent }}</pre>
      <span slot="footer" class="dialog-footer">
        <el-button @click="logMMesDialog = false">关 闭</el-button>
      </span>
    </el-dialog>
    <!-- 所有成功弹窗 -->
    <el-dialog
      :title="successTitle"
      :visible.sync="successDialog"
      width="600px"
      @open="noClick = false"
    >
      <div class="message">
        <p>{{ successContent }}</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="successClick">确 定</el-button>
        <el-button @click="successDialog = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Menu from "../../menu/menu.vue";
import LeftSideBar from "../../menu/leftSideBar.vue";
import $ from "jquery";
import cookies from "vue-cookies";
export default {
  data() {
    return {
      tableLoading: false,
      newType: 10,
      // 数据部分
      listTableData: [],
      multipleSelectionTable: [],
      listData: [],
      runtimeKey: "",
      logInterval: null,
      successTitle: "",
      successContent: "",
      runTimeTitle: "",
      checkLogTitle: "",
      logChechContent: "",
      startTime: "",
      headers: {
        AuthorizationToken: cookies.get("token"),
      },
      upLodeData: {
        type: "",
        sourceId: "",
        runtimeKey: "",
      },

      importUrl:"/zyk/storage/importData",

      // 文件上传部分
      fileType: "", // 文件类型
      fileList: [], //上传文件列表

      sourceList: [],
      currentPage: 1,
      pageSize: 10,
      totalSize: 0,
      sourceContent: "",
      dataText: "",
      activeName: "first",
      optionData: [],

      // 弹窗部分
      createDialog: false,
      transDialog: false,
      logMMesDialog: false,
      successDialog: false,
    };
  },
  components: {
    Menu,
    LeftSideBar,
  },
  mounted() {
    // 统一验证token
    var currentToken = cookies.get("token");
    $.ajaxSetup({
      headers: {
        AuthorizationToken: currentToken,
      },
      complete: function (xhr) {
        if (xhr.responseJSON.code == 401) {
          window.location.href = "/";
        }
      },
    });
    this.searchParam();
  },
  methods: {
    // 加载数据
    searchParam() {
      let that = this;
      this.getSourceList();
      if (this.sourceContent == "") {
        that.dataText = "请选择来源";
      } else {
        let params = {
          type: this.newType,
          size: this.pageSize,
          page: this.currentPage,
          sourceId: this.sourceContent,
        };
        that.tableLoading = true;
        $.ajax({
          type: "GET",
          dataType: "json",
          url: "/zyk/c/storage/storageInfo/list",
          data: params,
          contentType: "application/json;charset=utf-8",
          success: function (response) {
            if (response.code == 200) {
              that.optionData = response.obj.list;
              if (response.obj && response.obj.length == 0) {
                that.dataText = "暂无数据";
              }
              that.tableLoading = false;
              that.totalSize = response.obj.total;
              that.listTableData = response.obj.list;
              that.currentPage = response.obj.pageNum;
            } else {
              that.$message({
                message: response.msg,
                duration: 0,
                showClose: true,
                type: "error",
                offset: 100,
              });
            }
          },
          error: function (data) {
            console.log(data);
          },
        });
      }
    },
    // 点击tab切换
    handleClick(tab) {
      let that = this;
      switch (tab.index) {
        case "0": //条目资源入库
          that.newType = 10;
          that.sourceContent = "";
          that.listTableData = [];
          that.importUrl = "/zyk/storage/importData";
          break;
        case "1": //图书资源入库
          that.newType = 30;
          that.sourceContent = "";
          that.listTableData = [];
          break;
        case "2": //辞典工具类型数据入库
          that.newType = 20;
          that.sourceContent = "";
          that.listTableData = [];
          break;
        case "3": //专项数据资源入库
          that.newType = 40;
          that.sourceContent = "";
          that.listTableData = [];
          break;
        case "4": //文章数据入库
          that.newType = 120;
          that.sourceContent = "";
          that.listTableData = [];
          break;
        case "5": //论文数据入库
          that.newType = 130;
          that.sourceContent = "";
          that.listTableData = [];
          break;
        case "6": //问答对数据资源入库
          that.newType = 140;
          that.sourceContent = "";
          that.listTableData = [];
          that.importUrl = "/zyk/storage/importQaData";
          break;
      }
      that.searchParam();
    },
    // 显示上传资源包弹框
    firstCreate() {
      let that = this;
      that.getSourceList();
      that.fileList = [];
      this.createDialog = true;
    },

    // 编辑、删除、转正式前确认
    preCheck(current) {
      let that = this;
      let ids = this.multipleSelectionTable.map((item) => {
        return item.id;
      });
      var downloadA = document.createElement("a");
      let flagArr = [];
      let flag = true;
      if (this.multipleSelectionTable.length == 0) {
        this.$message({
          message: "请选中具体的资源",
          duration: 0,
          showClose: true,
          type: "error",
          offset: 100,
        });
      } else if (current == "totrans") {
        // 转换词条包
        let isChangeArr = this.multipleSelectionTable.map((item) => {
          return item.isChange;
        });

        $.each(isChangeArr, function (index, element) {
          if (element === 10) {
            flagArr.push(true);
          } else {
            flagArr.push(false);
          }
        });
        flag = flagArr.every(function (value) {
          return value;
        });
        if (!flag) {
          that.$message({
            message: "当前资源包已转换，请勿重复转换",
            duration: 0,
            showClose: true,
            type: "error",
            offset: 100,
          });
        } else {
          this.transDialog = true;
          this.runtimeKey = $.now();
          this.startTime = this.timestampToDate(this.runtimeKey);
          this.runTimeTitle = "数据转换";
          that.getRuntimeLog(this.runtimeKey);
          $.ajax({
            type: "POST",
            dataType: "json",
            data: {
              ids: ids.toString(),
              runtimeKey: this.runtimeKey,
            },
            url: "/zyk/storage/changeData",
            success: function (response) {
              if (response.code == 200) {
                clearInterval(that.logInterval);
                that.successDialog = true;
                that.transDialog = false;
                that.successTitle = "资源包转换结果";
                that.successContent = "转换成功！";
                $(".logContent").html("")
              } else {
                clearInterval(that.logInterval);
                that.$message({
                  message: response.msg,
                  duration: 0,
                  showClose: true,
                  type: "error",
                  offset: 100,
                });
              }
            },
            error: function (data) {
              clearInterval(that.logInterval);
              console.log(data);
            },
          });
        }
      } else if (current == "toimport") {
        // 资源导入
        let isImportArr = this.multipleSelectionTable.map((item) => {
          return item.isImport;
        });

        $.each(isImportArr, function (index, element) {
          if (element === 10) {
            flagArr.push(true);
          } else {
            flagArr.push(false);
          }
        });
        flag = flagArr.every(function (value) {
          return value;
        });
        if (!flag) {
          that.$message({
            message: "当前资源包已导入，请勿重复导入",
            duration: 0,
            showClose: true,
            type: "error",
            offset: 100,
          });
        } else {
          this.transDialog = true;
          this.runtimeKey = $.now();
          this.startTime = this.timestampToDate(this.runtimeKey);
          this.runTimeTitle = "数据导入";
          that.getRuntimeLog(this.runtimeKey);
          $.ajax({
            type: "POST",
            dataType: "json",
            data: {
              ids: ids.toString(),
              runtimeKey: this.runtimeKey,
            },
            // url: "/zyk/storage/importData",
            url: this.importUrl,
            success: function (response) {
              if (response.code == 200) {
                clearInterval(that.logInterval);
                that.successDialog = true;
                that.transDialog = false;
                that.successTitle = "资源包导入结果";
                that.successContent = "导入成功！";
                $(".logContent").html("")
              } else {
                clearInterval(that.logInterval);
                that.$message({
                  message: response.msg,
                  duration: 0,
                  showClose: true,
                  type: "error",
                  offset: 100,
                });
              }
            },
            error: function (data) {
              clearInterval(that.logInterval);
              that.transDialog = false;
              $(".logContent").html("")
              that.$message({
                message: data,
                duration: 0,
                showClose: true,
                type: "error",
                offset: 100,
              });
            },
          });
        }
      } else if (current == "getImprotLog") {
        if (this.multipleSelectionTable.length == 1) {
          if (this.multipleSelectionTable[0].isImport == 10) {
            this.$message({
              message: "当前资源未导入，请先导入资源再查看日志",
              duration: 0,
              showClose: true,
              type: "error",
              offset: 100,
            });
          } else {
            this.checkLogTitle = "导入日志查看";
            this.logMMesDialog = true;
            let currentId = ids[0];
            $.ajax({
              type: "GET",
              dataType: "json",
              data: {
                id: currentId,
              },
              url: "/zyk/storage/previewImportLog",
              success: function (response) {
                if (response.code == 200) {
                  that.logChechContent = response.obj.text;
                } else {
                  that.$message({
                    message: response.msg,
                    duration: 0,
                    showClose: true,
                    type: "error",
                    offset: 100,
                  });
                }
              },
              error: function (data) {
                console.log(data);
              },
            });
          }
        } else {
          this.$message({
            message: "请勿选择多个资源查看日志",
            duration: 0,
            showClose: true,
            type: "error",
            offset: 100,
          });
        }
      } else if (current == "getTransLog") {
        if (this.multipleSelectionTable.length == 1) {
          if (this.multipleSelectionTable[0].isChange == 10) {
            this.$message({
              message: "当前资源未转换，请先转换资源再查看日志",
              duration: 0,
              showClose: true,
              type: "error",
              offset: 100,
            });
          } else {
            this.checkLogTitle = "转换日志查看";
            this.logMMesDialog = true;
            let currentId = ids[0];
            $.ajax({
              type: "GET",
              dataType: "json",
              data: {
                id: currentId,
              },
              url: "/zyk/storage/previewChangeLog",
              success: function (response) {
                if (response.code == 200) {
                  that.logChechContent = response.obj.text;
                } else {
                  that.$message({
                    message: response.msg,
                    duration: 0,
                    showClose: true,
                    type: "error",
                    offset: 100,
                  });
                }
              },
              error: function (data) {
                console.log(data);
              },
            });
          }
        } else {
          this.$message({
            message: "请勿选择多个资源查看日志",
            duration: 0,
            showClose: true,
            type: "error",
            offset: 100,
          });
        }
      } else if (current == "transLogDownload") {
        if (this.multipleSelectionTable.length == 1) {
          if (this.multipleSelectionTable[0].isChange == 10) {
            this.$message({
              message: "当前资源未转换，请先转换资源再下载日志",
              duration: 0,
              showClose: true,
              type: "error",
              offset: 100,
            });
          } else {
            let currentId = ids[0];
            $.ajax({
              type: "GET",
              dataType: "json",
              data: {
                id: currentId,
              },
              url: "/zyk/storage/downloadChangeLog",
              success: function (response) {
                if (response.code == 200) {
                  downloadA.href = response.obj.url;
                  downloadA.download;
                  downloadA.click();
                } else {
                  that.$message({
                    message: response.msg,
                    duration: 0,
                    showClose: true,
                    type: "error",
                    offset: 100,
                  });
                }
              },
              error: function (data) {
                console.log(data);
              },
            });
          }
        } else {
          this.$message({
            message: "请勿选择多个资源下载日志",
            duration: 0,
            showClose: true,
            type: "error",
            offset: 100,
          });
        }
      } else if (current == "importLogDownload") {
        if (this.multipleSelectionTable.length == 1) {
          if (this.multipleSelectionTable[0].isImport == 10) {
            this.$message({
              message: "当前资源未导入，请先导入资源再下载日志",
              duration: 0,
              showClose: true,
              type: "error",
              offset: 100,
            });
          } else {
            let currentId = ids[0];
            $.ajax({
              type: "GET",
              dataType: "json",
              data: {
                id: currentId,
              },
              url: "/zyk/storage/downloadImportLog",
              success: function (response) {
                if (response.code == 200) {
                  downloadA.href = response.obj.url;
                  downloadA.download;
                   downloadA.click();
                } else {
                  that.$message({
                    message: response.msg,
                    duration: 0,
                    showClose: true,
                    type: "error",
                    offset: 100,
                  });
                }
              },
              error: function (data) {
                console.log(data);
              },
            });
          }
        } else {
          this.$message({
            message: "请勿选择多个资源下载日志",
            duration: 0,
            showClose: true,
            type: "error",
            offset: 100,
          });
        }
      }
    },
    // 获取实时日志
    getRuntimeLog(runtimeKey) {
      let that = this;
      this.logInterval = setInterval(function () {
        $.ajax({
          type: "GET",
          dataType: "json",
          data: { runtimeKey: runtimeKey, timeCurrent: $.now() },
          url: "/zyk/storage/runtimeLog",
          success: function (response) {
            if (response.code == 200) {
              if (response.obj == null) {
                $(".logContent").text("正在操作...");
              } else {
                $(".logContent").text(response.obj);
              }
              if (response.obj.indexOf("转换完成") !== -1) {
                clearInterval(that.logInterval);
                this.successDialog = true;
                this.transDialog = false;
                this.successTitle = "资源包转换结果";
                this.successContent = "转换成功！";
              } else if (response.obj.indexOf("导入完成") !== -1) {
                clearInterval(that.logInterval);
                that.successDialog = true;
                that.transDialog = false;
                that.successTitle = "资源包导入结果";
                that.successContent = "导入成功！";
              }
            } else {
              that.$message({
                message: response.msg,
                duration: 0,
                showClose: true,
                type: "error",
                offset: 100,
              });
            }
          },
          error: function (data) {
            console.log(data);
          },
        });
      }, 1000);
      this.transDialog = true;
    },
    // 选择表格某一行
    handleTableSelectionChange(val) {
      this.multipleSelectionTable = val;
    },
    // 分页
    handleSizeChange(val) {
      this.pageSize = val;
      this.searchParam();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.searchParam();
    },
    // 文件上传
    submitUpload() {
      this.$refs.upload.data.type = this.newType;
      this.$refs.upload.data.runtimeKey = $.now();
      this.$refs.upload.data.sourceId = this.sourceContent;
      this.$refs.upload.submit();
    },

    // 上传文件之前的钩子，对文件大小进行校验
    beforeUpload(file) {
      const isLt2M = file.size / 1024 / 1024 / 1024 < 4;
      if (!isLt2M) {
        this.$message.error("资源超过上传上限4G，如仍需上传，请联系管理员。");
        return isLt2M;
      } else {
        this.upLodeData = {
          type: this.newType,
          runtimeKey: $.now(),
        };
      }
    },
    // 上传成功的钩子
    uploadSuccess() {
      let that = this;
      this.successDialog = true;
      this.successTitle = "资源包上传结果";
      this.successContent = "上传成功！";
      that.createDialog = false;
    },
    // 时间戳转换
    timestampToDate(timestamp) {
      var date = new Date(timestamp); // 将时间戳转换为Date对象
      return date.toISOString().slice(0, 10); // 将Date对象转换为YYYY-MM-DD格式
    },
    // 获取来源list
    getSourceList() {
      let that = this;
      $.ajax({
        url: "/zyk/c/source/sourceInfo/list",
        type: "GET",
        dataType: "json",
        data: {
          type: this.newType,
          page: 1,
          size: 1000,
        },
        success: function (response) {
          if (response.code == 200) {
            that.optionData = response.obj.list;
            if (response.obj && response.obj.list.length == 0) {
              that.dataText = "暂无数据";
            }
            that.sourceList = response.obj.list;
          } else {
            that.$message({
              message: response.msg,
              duration: 0,
              showClose: true,
              type: "error",
              offset: 100,
            });
          }
        },
        error: function (data) {
          console.log(data);
        },
      });
    },
    // 成功弹窗事件
    successClick() {
      let that = this;
      this.successDialog = false;
      that.searchParam();
    },
    // 选择来源时table刷新
    tableRefresh() {
      let that = this;
      let currentSource = this.sourceContent;
      console.log(currentSource);
      that.searchParam();
    },
    // 问答对下载导入模板
    templateDownload() {
      let that = this;
      var downloadA = document.createElement("a");
      $.ajax({
        type: "GET",
        dataType: "json",
        url: "/zyk/qa/downloadTemplate",
        headers: {
            AuthorizationToken: cookies.get("token"),
        },
        // contentType: "text/xml",
        success: function (response) {
          if (response.code == 200) {
            downloadA.href = response.obj.url;
            downloadA.download;
            downloadA.click();
          } else {
            that.$message({
              message: response.msg,
              duration: 0,
              showClose: true,
              type: "error",
              offset: 100,
            });
          }
        },
        error: function (data) {
          console.log(data);
        },
      });
    },
  },
};
</script>

<style>
.maintable .el-button.is-circle {
  border: none;
}

.message {
  margin-bottom: 30px;
}

.message p {
  font-size: 16px;
  margin: 10px 0;
}

.content {
  border: 1px solid #ddd;
  border-radius: 10px;
  width: 100%;
  height: 100px;
}

.sourceBox {
  margin-bottom: 20px;
}

.sourceBox .sourceTitle {
  font-size: 15px;
  margin-right: 15px;
}


#allBox{
  /* display: none; */
  position: absolute;
  z-index: 999;
  background: #fff;
  padding: 20px 30px;
  top: 40px;
  left: 10px;
  box-shadow: 0 0 1px #888;
  border-radius: 5px;
}
</style>